import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { SHOW_ALL_NEXT_MOVE_CARDS } from "./showAllNextMoveCards";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const HealthSurveyNextMoveCard = () => {
  const {
    hasCompletedEnoughOfGettingStartedSurvey,
    hasReportedCancer,
    memberNeedsToTalkToNav
  } = useNextMoveMemberContext();

  if (
    !SHOW_ALL_NEXT_MOVE_CARDS &&
    (hasReportedCancer ||
      hasCompletedEnoughOfGettingStartedSurvey ||
      memberNeedsToTalkToNav)
  ) {
    return null;
  }

  return (
    <NextMoveCard
      id="guided-insights-next-move"
      title={<Translate text="Request your DNA screening" />}
      body={
        <Translate text="Your Genomic Life membership includes access to DNA screenings that can help you take steps to stay healthy, longer." />
      }
      subBody={
        <Translate text="Simply answer a few questions and we'll suggest tests that may be right for you." />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "precision_guidance_survey",
            ctaLocation: "next_move_card",
            ctaId: "precision_guidance_survey"
          });
        },
        url: PATHS.GETTING_STARTED_SURVEY
      }}
    />
  );
};

export default HealthSurveyNextMoveCard;
